import React, { FC, useEffect } from "react";
import { shallowEqual } from "react-redux";
import { useAppDispatch } from "../../store/hooks/dispatch.hook";
import { useAppSelector } from "../../store/hooks/selector.hook";
import { getEmployeesListFetch, getTeachersListFetch } from "../../store/state/employees/employees.slice";
import { SYSTEM_ADMIN_ID } from "../../utl/constants/role";
import { culcPage } from "../../utl/helpers/culcPage";
import { Filter } from "../../utl/models/Filters";

function withLoadingEmloyess(Component: React.ComponentType) {
    const ComponentWithLoadingEmloyess: FC = () => {
        const dispatch = useAppDispatch();
        const page = useAppSelector(state => state.employees.page, shallowEqual);
        const totalCount = useAppSelector(state => state.employees.totalCount, shallowEqual);
        const pageAll = useAppSelector(state => state.employees.pageAll, shallowEqual);
        const pageSize = useAppSelector(state => state.employees.pageSize, shallowEqual);
        const getAllItems = useAppSelector(state => state.employees.getAllItems, shallowEqual);
        const pagesRange = culcPage(page, pageAll, totalCount, pageSize);
        const vendorId = useAppSelector(state => state.user.vendorId, shallowEqual) || -1;
        const roleId = useAppSelector(state => state.user.roleId, shallowEqual) || -1;

        useEffect(() => {
            if (roleId > SYSTEM_ADMIN_ID) {
                let filter: Filter = {};

                if (!getAllItems) {
                    filter.range = {
                        from: pagesRange.from,
                        to: pagesRange.to
                    }
                }

                dispatch(getEmployeesListFetch({ vendorId, filter }));
                dispatch(getTeachersListFetch({ vendorId }));
            }
        }, [vendorId, roleId]);

        return (
            <Component />
        );
    }

    return ComponentWithLoadingEmloyess;
}

export default withLoadingEmloyess;